import React from 'react';
import MessageModal from '@portal/components/MessageModal/MessageModal';
import { translate } from '@portal/services/i18n';
import useReduxState from '@portal/hooks/useReduxState';
import { DateTime } from 'luxon';
import { TransferTabs } from '@portal/enum/transferTabs';

type ScheduleAlertModalProps = {
  isAlertVisible: boolean;
  setTabKey: (key: TransferTabs) => void;
  setIsAlertVisible: (value: boolean) => void;
};

const ScheduleAlertModal = ({
  isAlertVisible,
  setTabKey,
  setIsAlertVisible,
}: ScheduleAlertModalProps) => {
  const {
    settings: { remoteConfig },
  } = useReduxState();

  return (
    <MessageModal
      open={isAlertVisible}
      onConfirm={() => {
        setTabKey(TransferTabs.CONFIRMATION);
        setIsAlertVisible(false);
      }}
      onCancel={() => setIsAlertVisible(false)}
      setVisible={setIsAlertVisible}
      buttonOkText={translate(
        'PAGES.HOME.TRANSFER.SCHEDULED_TED_WARN.BUTTONS.CONTINUE'
      )}
      buttonCancelText={translate(
        'PAGES.HOME.TRANSFER.SCHEDULED_TED_WARN.BUTTONS.CANCEL'
      )}
      title={translate('PAGES.HOME.TRANSFER.SCHEDULED_TED_WARN.TITLE')}
      message={`${translate(
        'PAGES.HOME.TRANSFER.SCHEDULED_TED_WARN.TEXT'
      )}${DateTime.fromFormat(
        remoteConfig?.tedTimeLimits.min ?? '08:00',
        'HH:mm',
        {
          zone: 'utc',
        }
      )
        .toLocal()
        .toFormat('HH:mm')}
    ${translate(
      'PAGES.HOME.TRANSFER.SCHEDULED_TED_WARN.AT'
    )}${DateTime.fromFormat(
        remoteConfig?.tedTimeLimits.max ?? '17:00',
        'HH:mm',
        {
          zone: 'utc',
        }
      )
        .toLocal()
        .toFormat('HH:mm')}${translate(
        'PAGES.HOME.TRANSFER.SCHEDULED_TED_WARN.DAYS'
      )}`}
    />
  );
};

export default ScheduleAlertModal;
